"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var CaretUp_1 = __importDefault(require("@acl-services/wasabicons/lib/CaretUp"));
var CaretDown_1 = __importDefault(require("@acl-services/wasabicons/lib/CaretDown"));
var organizationShape_1 = __importDefault(require("../organizationShape"));
var DefaultLogo_1 = __importDefault(require("./DefaultLogo"));
var OrgSwitcher_1 = __importDefault(require("../OrgSwitcher/OrgSwitcher"));
var sc = __importStar(require("./OrganizationSwitcher.styles"));
function OrganizationSwitcher(_a) {
    var activeOrganizationId = _a.activeOrganizationId, organizations = _a.organizations, logoText = _a.logoText, otherText = _a.otherText, moreProps = __rest(_a, ["activeOrganizationId", "organizations", "logoText", "otherText"]);
    var activeOrganization = react_1.default.useMemo(function () { return organizations.find(function (organization) { return organization.id === activeOrganizationId; }); }, [organizations]);
    function renderOrganizationValue(ariaLabel, onClick, isExpanded, triggerRef) {
        if (organizations.length === 1) {
            return (react_1.default.createElement(sc.OrgSwitcherSimple, { "aria-label": ariaLabel, "data-sri-anchor": "org-switcher" },
                activeOrganization.logo ? (react_1.default.createElement(sc.LogoWrapper, { "data-sri-anchor": "logo-wrapper" },
                    react_1.default.createElement("img", { alt: activeOrganization.name + " " + logoText, src: activeOrganization.logo, "data-sri-anchor": "org-switcher.company-logo" }))) : (react_1.default.createElement(DefaultLogo_1.default, null)),
                react_1.default.createElement(sc.OrgSwitcherValueWrapper, { "data-sri-anchor": "org-switcher.value-wrapper" },
                    react_1.default.createElement(sc.OrgSwitcherValue, { "data-sri-anchor": "org-switcher.value", "data-testid": "orgSwitcherCustomerName" }, activeOrganization.name))));
        }
        return (react_1.default.createElement(sc.OrgSwitcherListboxWrapper, { "data-sri-anchor": "org-switcher.listbox-wrapper" },
            react_1.default.createElement(sc.OrgSwitcherTrigger, { ariaLabel: ariaLabel, "data-sri-anchor": "org-switcher", onClick: onClick, ref: triggerRef },
                activeOrganization.logo ? (react_1.default.createElement(sc.LogoWrapper, { "data-sri-anchor": "logo-wrapper" },
                    react_1.default.createElement("img", { alt: activeOrganization.customerName + " " + activeOrganization.name + " " + logoText, src: activeOrganization.logo, "data-sri-anchor": "org-switcher.company-logo" }))) : (react_1.default.createElement(DefaultLogo_1.default, { "data-sri-anchor": "org-switcher.default-logo" })),
                react_1.default.createElement(sc.OrgSwitcherValueWrapper, { "data-sri-anchor": "org-switcher.value-wrapper" },
                    activeOrganization.customerName && (react_1.default.createElement(sc.OrgSwitcherValue, { "data-sri-anchor": "org-switcher.value", "data-testid": "orgSwitcherCustomerName" }, activeOrganization.customerName)),
                    react_1.default.createElement(sc.OrgSwitcherValue, { "data-sri-anchor": "org-switcher.value", "data-testid": "orgSwitcherOrganizationName" }, activeOrganization.name)),
                isExpanded ? react_1.default.createElement(CaretUp_1.default, { color: tokens_1.default.color.white }) : react_1.default.createElement(CaretDown_1.default, { color: tokens_1.default.color.white }))));
    }
    return (react_1.default.createElement(OrgSwitcher_1.default, __assign({}, moreProps, { className: "organization-switcher-wrapper", organizations: organizations, renderTrigger: renderOrganizationValue, selectedOrg: {
            id: activeOrganization.id,
            heading: activeOrganization.customerName || otherText,
            title: activeOrganization.name,
            logo: activeOrganization.logo,
            isSelected: false,
        } })));
}
var commonPropTypes = {
    activeOrganizationId: prop_types_1.default.number.isRequired,
    organizations: prop_types_1.default.arrayOf(prop_types_1.default.shape(organizationShape_1.default)).isRequired,
};
OrganizationSwitcher.propTypes = __assign(__assign({}, commonPropTypes), { logoText: prop_types_1.default.string.isRequired, otherText: prop_types_1.default.string.isRequired });
function OrganizationSwitcherWithContext(props) {
    var i18n = useI18n_1.default();
    return (react_1.default.createElement(OrganizationSwitcher, __assign({}, props, { logoText: i18n.t('global_navigation.logo'), otherText: i18n.t('global_navigation.other') })));
}
OrganizationSwitcherWithContext.propTypes = commonPropTypes;
exports.default = OrganizationSwitcherWithContext;
//# sourceMappingURL=OrganizationSwitcher.js.map